/**
 * @generated SignedSource<<fc7185769dd4d8e186792ba39f93e9fa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DelegatesOrder = "mostDelegates" | "mostVotes" | "mostVotesMostPower" | "mostVotingPower" | "%future added value";
export type DelegatesWhere = "withStatement" | "withoutStatement" | "%future added value";
export type HomePageRouteQuery$variables = {
  filterBy?: DelegatesWhere | null;
  orderBy: DelegatesOrder;
};
export type HomePageRouteQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"DelegatesContainerFragment" | "OverviewMetricsContainerFragment">;
};
export type HomePageRouteQuery = {
  response: HomePageRouteQuery$data;
  variables: HomePageRouteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterBy"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v2 = {
  "kind": "Variable",
  "name": "orderBy",
  "variableName": "orderBy"
},
v3 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 30
  },
  (v2/*: any*/),
  {
    "kind": "Variable",
    "name": "where",
    "variableName": "filterBy"
  }
],
v4 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "decimals",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currency",
    "storageKey": null
  }
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "TokenAmount",
  "kind": "LinkedField",
  "name": "amount",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v6 = [
  (v5/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "bpsOfTotal",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "HomePageRouteQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "filterBy",
            "variableName": "filterBy"
          },
          (v2/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "DelegatesContainerFragment"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "OverviewMetricsContainerFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "HomePageRouteQuery",
    "selections": [
      {
        "alias": "voters",
        "args": (v3/*: any*/),
        "concreteType": "DelegatesConnection",
        "kind": "LinkedField",
        "name": "delegates",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DelegatesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Delegate",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Address",
                    "kind": "LinkedField",
                    "name": "address",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ResolvedName",
                        "kind": "LinkedField",
                        "name": "resolvedName",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "address",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DelegateStatement",
                    "kind": "LinkedField",
                    "name": "statement",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "summary",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "twitter",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "discord",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "VotingPower",
                    "kind": "LinkedField",
                    "name": "tokensRepresented",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "voters",
        "args": (v3/*: any*/),
        "filters": [
          "orderBy",
          "where"
        ],
        "handle": "connection",
        "key": "DelegatesContainerFragment_voters",
        "kind": "LinkedHandle",
        "name": "delegates"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Metrics",
        "kind": "LinkedField",
        "name": "metrics",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TokenAmount",
            "kind": "LinkedField",
            "name": "delegatedSupply",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TokenAmount",
            "kind": "LinkedField",
            "name": "totalSupply",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VotingPower",
            "kind": "LinkedField",
            "name": "quorum",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VotingPower",
            "kind": "LinkedField",
            "name": "proposalThreshold",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7cb999ebf396bf94d50e13654825620d",
    "id": null,
    "metadata": {},
    "name": "HomePageRouteQuery",
    "operationKind": "query",
    "text": "query HomePageRouteQuery(\n  $orderBy: DelegatesOrder!\n  $filterBy: DelegatesWhere\n) {\n  ...DelegatesContainerFragment_MrXhA\n  ...OverviewMetricsContainerFragment\n}\n\nfragment DelegateProfileImageFragment on Delegate {\n  address {\n    resolvedName {\n      address\n      ...NounResolvedNameFragment\n      ...ENSAvatarFragment\n    }\n  }\n  tokensRepresented {\n    amount {\n      ...TokenAmountAsCurrencyDisplayFragment\n    }\n  }\n}\n\nfragment DelegatesContainerFragment_MrXhA on Query {\n  voters: delegates(first: 30, orderBy: $orderBy, where: $filterBy) {\n    edges {\n      node {\n        id\n        ...VoterCardFragment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ENSAvatarFragment on ResolvedName {\n  name\n}\n\nfragment NounResolvedNameFragment on ResolvedName {\n  address\n  name\n}\n\nfragment OverviewMetricsContainerFragment on Query {\n  metrics {\n    delegatedSupply {\n      amount\n      ...TokenAmountAsCurrencyDisplayFragment\n    }\n    totalSupply {\n      amount\n      ...TokenAmountAsCurrencyDisplayFragment\n    }\n    quorum {\n      amount {\n        ...TokenAmountAsCurrencyDisplayFragment\n      }\n      bpsOfTotal\n    }\n    proposalThreshold {\n      amount {\n        ...TokenAmountAsCurrencyDisplayFragment\n      }\n      bpsOfTotal\n    }\n  }\n}\n\nfragment TokenAmountAsCurrencyDisplayFragment on TokenAmount {\n  amount\n  decimals\n  currency\n}\n\nfragment VoterCardFragment on Delegate {\n  address {\n    resolvedName {\n      address\n      name\n      ...NounResolvedNameFragment\n    }\n  }\n  statement {\n    summary\n  }\n  ...VoterPanelActionsFragment\n  ...DelegateProfileImageFragment\n}\n\nfragment VoterPanelActionsDelegateButtonFragment on Delegate {\n  address {\n    resolvedName {\n      address\n    }\n  }\n}\n\nfragment VoterPanelActionsFragment on Delegate {\n  statement {\n    twitter\n    discord\n  }\n  ...VoterPanelActionsDelegateButtonFragment\n}\n"
  }
};
})();

(node as any).hash = "d7e3fed616e1a4cac22bd259ad92f075";

export default node;
